/**
 * useGoalQueries — React Query wrapper for fetching user goals with todos and subtasks.
 *
 * Note: goal mutations live in `useGoalOperations` (the canonical writer).
 * This hook is read-only.
 */
import { useGoalFetching } from "./queries/useGoalFetching";
import { useTodoFetching } from "./queries/useTodoFetching";
import { useQueryInvalidation } from "./queries/useQueryInvalidation";
import { useAuth } from "./useAuth";

export const useGoalQueries = () => {
  const { user } = useAuth();
  const { goals, isLoading, error } = useGoalFetching();
  const { fetchUserTodos } = useTodoFetching();
  const { invalidateGoals } = useQueryInvalidation();

  if (!user) {
    return {
      goals: [],
      isLoading: false,
      error: null,
      invalidateGoals: () => Promise.resolve(),
      fetchUserTodos: () => Promise.resolve([])
    };
  }

  return {
    goals,
    isLoading,
    error,
    invalidateGoals,
    fetchUserTodos
  };
};
